import { fetchUpdatesUnreadCountsFn, fetchUserUpdatesFn } from './updates'

const updatesApi = {
  getUpdates: {
    key: 'FETCH_UPDATES',
    fn: fetchUserUpdatesFn,
  },
  getUpdatesUnreadCount: {
    key: 'FETCH_UPDATES_UNREAD_COUNTS',
    fn: fetchUpdatesUnreadCountsFn,
  },
}

export default updatesApi
